import React, { useEffect, useState } from "react";
import Footer from "../Footer";
import Icon_Info_curso from "../Certificacion/Icon_Info_curso";
import "../Certificacion/Curso.css";
import Card_info_curso from "../Certificacion/Card_info_curso";
import telefono from "../../images/Phone.png";
import data from "../data/posgrados.json";
import calendario from "../../images/Calendar.png";
import arancel from "../../images/Bank.png";
import candado from "../../images/Closed.png";
import ubicacion from "../../images/Ubication.png";
import monedas from "../../images/Tax.png";
import correo from "../../images/Mail_.png";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { useParams } from "react-router-dom";
import { Button, Header, Icon, Modal } from "semantic-ui-react";
import LoginForm from "../../features/users/LoginForm";
import RegisterForm from "../../features/users/RegisterForm";
import { useStore } from "../../app/stores/store";
import PagoModal from "../Modals/PagoModal";
import ActualizacionModal from "../Modals/ActualizacionModal";
import PreinscripcionModal from "../Modals/PreinscripcionModal";
import CodigoInstitucional from "../Modals/CodigoInstitucional";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#53c0fa",
    color: theme.palette.common.white,
    fontWeight: "bold",
    fontFamily: "Gotham",
    fontSize: 15,
  },
  body: {
    fontSize: 15,
    fontFamily: "Gotham",
    color: theme.palette.common.white,
  },
}))(TableCell);

const loadImage = (imageName: any) =>
  require(`../../images/${imageName}`).default;

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(even)": {
      backgroundColor: "#53c0fa",
    },
    "&:nth-of-type(odd)": {
      backgroundColor: "#258cc3",
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  table: {
    maxWidth: "716px",
  },
});

function Posgrado() {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const {
    InscriptionsStore,
    userStore: { logout, isLoggedIn },
    modalStore,
  } = useStore();
  const { createInscription, update_SGPersonas } = InscriptionsStore;
  const { id } = useParams<{ id: any }>();
  const { idUser } = useParams<{ idUser: string }>();
  const datos = data.filter((nombre) => {
    return nombre.id == id;
  });
  return (
    <>
      {datos.map((postDetail) => {
        return (
          <div key={postDetail.id}>
            <img
              src={loadImage(postDetail.imagen)}
              alt="imagen"
              style={{ width: "100%" }}
            ></img>
            <h1 className="titulo">{postDetail.edicion}</h1>
            <div id="icon_info">
              <div className="icon__container">
                <div className="icon__wrapper">
                  <ul className="cards__items">
                    <Icon_Info_curso
                      icono={calendario}
                      titulo="Fecha del curso"
                      info={
                        postDetail.fecha_inicio + " - " + postDetail.fecha_final
                      }
                    />
                    <Icon_Info_curso
                      icono={candado}
                      titulo="Cierre de inscripciones"
                      info={postDetail.cierre_inscripcion}
                    />
                    <Icon_Info_curso
                      icono={ubicacion}
                      titulo="Modalidad"
                      info={postDetail.modalidad}
                    />
                  </ul>
                </div>
              </div>
              <hr className="hr"></hr>
              <br></br>
              <div className="contenedor_info_general_curso">
                <div className="curso_text">
                  {postDetail.informacion_general.map((detail) => {
                    if (
                      detail.titulo === "Competencias" ||
                      detail.titulo === "Requisitos de ingreso" ||
                      detail.titulo === "Documentos requeridos" ||
                      detail.titulo === "Modalidad"
                    ) {
                      return (
                        <div>
                          <h2>{detail.titulo}</h2>
                          {detail.info.map((comp) => {
                            return (
                              <div>
                                <p>{"- " + comp.descripcion}</p>
                              </div>
                            );
                          })}
                          <br></br>
                        </div>
                      );
                    } else {
                      return (
                        <div>
                          <h2>{detail.titulo}</h2>
                          {detail.info.map((comp) => {
                            return (
                              <div>
                                <p>{comp.descripcion}</p>
                                <br></br>
                              </div>
                            );
                          })}
                        </div>
                      );
                    }
                  })}
                  <br></br>
                  <TableContainer>
                    <Table
                      className={classes.table}
                      aria-label="customized table"
                    >
                      <TableBody style={{ border: "1px solid " }}>
                        {postDetail.malla.map((data_Index) => {
                          return (
                            <StyledTableRow
                              style={{ border: "3px solid white" }}
                            >
                              {data_Index.filas.map((index) => {
                                return (
                                  <StyledTableCell
                                    component="th"
                                    scope="row"
                                    align="center"
                                    style={{ border: "3px solid white" }}
                                  >
                                    {index.informacion}
                                  </StyledTableCell>
                                );
                              })}
                            </StyledTableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <br></br>
                  <TableContainer>
                    <Table
                      className={classes.table}
                      aria-label="customized table"
                    >
                      <TableHead>
                        <TableRow>
                          <StyledTableCell
                            align="center"
                            style={{ border: "3px solid white" }}
                          >
                            Cohortes
                          </StyledTableCell>
                          <StyledTableCell
                            align="center"
                            style={{ border: "3px solid white" }}
                          >
                            Trimestre
                          </StyledTableCell>
                          <StyledTableCell
                            align="center"
                            style={{ border: "3px solid white" }}
                          >
                            Inicio 2021
                          </StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {postDetail.cohortes.map((datapost) => {
                          return (
                            <StyledTableRow
                              key={datapost.cohorte}
                              style={{ border: "3px solid white" }}
                            >
                              <StyledTableCell
                                component="th"
                                scope="row"
                                align="center"
                              >
                                {datapost.cohorte}
                              </StyledTableCell>
                              <StyledTableCell
                                align="center"
                                style={{ border: "3px solid white" }}
                              >
                                {datapost.trimestre}
                              </StyledTableCell>
                              <StyledTableCell
                                align="center"
                                style={{ border: "3px solid white" }}
                              >
                                {datapost.inscripcion_inicio}
                              </StyledTableCell>
                            </StyledTableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <br></br>
                </div>
                <div className="contenedor_cards_info_curso">
                  <div className="portafolio-text" id="indcripcion_boton">
                    {isLoggedIn ? (
                      <>
                        {postDetail.solicitud == "inscripcion" ? (
                          <Modal
                            closeIcon
                            size="mini"
                            open={open}
                            trigger={
                              <Button
                                color="blue"
                                className="boton_inscripcion"
                                style={{
                                  fontFamily: "Gotham-Bold",
                                  borderRadius: "20px",
                                  color: "white",
                                  fontSize: "17px",
                                }}
                              >
                                {" "}
                                no no
                              </Button>
                            }
                            onClose={() => setOpen(false)}
                            onOpen={() => setOpen(true)}
                          >
                            <Modal.Content>
                              <h4>¿Seguro que quiere inscribirse?</h4>
                              <div className="botones_modal">
                                <Button
                                  style={{
                                    backgroundColor: "#15b3e8",
                                    color: "white",
                                  }}
                                  onClick={() => {
                                    setOpen(false);
                                    modalStore.openModal(
                                      <CodigoInstitucional
                                        userId={idUser}
                                        curso={id}
                                        tipo={"inscripcion"}
                                        monto={postDetail.arancel}
                                        codigoBanco={postDetail.codigo}
                                        nombreCurso={undefined}
                                      />,
                                      'mini'
                                    );
                                  }}
                                >
                                  Si
                                </Button>
                                <Button
                                  color="blue"
                                  onClick={() => {
                                    setOpen(false);
                                  }}
                                >
                                  No
                                </Button>
                              </div>
                            </Modal.Content>
                          </Modal>
                        ) : (
                          <Modal
                            closeIcon
                            size="mini"
                            open={open}
                            trigger={
                              <Button
                                color="blue"
                                className="boton_inscripcion"
                                style={{
                                  fontFamily: "Gotham-Bold",
                                  borderRadius: "20px",
                                  color: "white",
                                  fontSize: "17px",
                                }}
                              >
                                {" "}
                                Preinscribete aquí
                              </Button>
                            }
                            onClose={() => setOpen(false)}
                            onOpen={() => setOpen(true)}
                          >
                            <Modal.Content>
                              <h4>¿Seguro que quiere inscribirse?</h4>
                              <div className="botones_modal">
                                <Button
                                  style={{
                                    backgroundColor: "#15b3e8",
                                    color: "white",
                                  }}
                                  onClick={() => {
                                    setOpen(false);
                                    modalStore.openModal(
                                      <CodigoInstitucional
                                        userId={idUser}
                                        curso={id}
                                        tipo={"preinscripcion"}
                                        monto={postDetail.arancel}
                                        codigoBanco={postDetail.codigo}
                                        nombreCurso={undefined}
                                      />,
                                      'mini'
                                    );
                                  }}
                                >
                                  Si
                                </Button>
                                <Button
                                  color="blue"
                                  onClick={() => {
                                    setOpen(false);
                                  }}
                                >
                                  No
                                </Button>
                              </div>
                            </Modal.Content>
                          </Modal>
                        )}
                      </>
                    ) : (
                      <>
                        <Modal
                          closeIcon
                          size="mini"
                          open={open}
                          trigger={
                            <Button
                              className="boton_inscripcion"
                              style={{
                                fontFamily: "Gotham-Bold",
                                backgroundColor: "#15b2e7",
                                borderRadius: "20px",
                                color: "white",
                                fontSize: "17px",
                              }}
                            >
                              {" "}
                              Inscribete aquí
                            </Button>
                          }
                          onClose={() => setOpen(false)}
                          onOpen={() => setOpen(true)}
                        >
                          <Modal.Content>
                            <p>
                              Para poder inscribirte tienes que haber ingresado
                              a la plataforma.
                            </p>
                            <div className="botones_modal">
                              <Button
                                style={{
                                  backgroundColor: "#15b3e8",
                                  color: "white",
                                }}
                                onClick={() => {
                                  setOpen(false);
                                  modalStore.openModal(<LoginForm />, 'mini');
                                }}
                              >
                                Ingresar
                              </Button>
                              <Button
                                color="blue"
                                onClick={() => {
                                  setOpen(false);
                                  modalStore.openModal(
                                    <RegisterForm />,
                                    'mini'
                                  );
                                }}
                              >
                                Registrarte
                              </Button>
                            </div>
                          </Modal.Content>
                        </Modal>
                      </>
                    )}
                  </div>
                  <div className="div1">
                    <Card_info_curso
                      title="Inversión mensual"
                      des={"Q" + postDetail.arancel}
                      icono={monedas}
                    />
                  </div>
                  <div className="div2">
                    <Card_info_curso
                      title="Inversión anual"
                      des={"Q" + postDetail.arancel}
                      icono={monedas}
                    />
                  </div>
                  <div className="div1">
                    <Card_info_curso
                      title="Código Inscripción"
                      des={postDetail.codigo}
                      icono={arancel}
                    />
                  </div>

                  <div className="div2">
                    <Card_info_curso
                      title="Correo"
                      des={postDetail.correo}
                      icono={correo}
                    />
                  </div>
                  <div className="div1">
                    <Card_info_curso
                      title="Teléfono"
                      des={postDetail.telefono}
                      icono={telefono}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
      <Footer />
    </>
  );
}

export default Posgrado;
